<template>
  <v-container fluid fill-height class="text-center">
    <v-row class="justify-left mt-5">
      <template v-for="(item, idx) in modulos">
        <v-col v-if="checkPermissions(item.per)" cols="12" xs="12" md="4" :key="idx">
          <v-card class="mx-auto" max-width="344" :color="item.color || 'secondary'" dark elevation="5">
            <v-card-title class="text-h5 justify-center">
              {{ item.nombre }}
            </v-card-title>
            <v-card-subtitle>
              {{ item.descripcion }}
            </v-card-subtitle>
            <v-card-text>
              <v-icon size="100">
                {{ item.icono }}
              </v-icon>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn block outlined @click="$router.push(item.path)">Ingresar</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-col>
      </template>
    </v-row>
    <v-snackbar v-model="success" color="success" :timeout="2500" bottom right>
      {{ msgSuccess }}
    </v-snackbar>
    <v-snackbar v-model="error" color="error" :timeout="2500" bottom right>
      {{ msgError }}
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: "home",
  data: () => ({
    loading: false,
    success: false,
    msgSuccess: "",
    error: false,
    msgError: "",
    logo: require("@/assets/logo_home.png"),
    modulos: [
      { nombre: "Catálogos", descripcion: "Administra los catálogos generales", icono: "mdi-book-open-variant", path: "/admin/catalogues", per: "CATALOGOS_" },
      { nombre: "Empleados", descripcion: "Administra los empleados y sus roles", icono: "mdi-account-multiple", path: "/admin/employees", per: "EMPLEADOS_" },
      { nombre: "Instructores", descripcion: "Administra los instructores", icono: "mdi-card-account-details", path: "/admin/instructors", per: "INSTRUCTORES_" },
      { nombre: "Eventos", descripcion: "Administra los eventos", icono: "mdi-calendar-star", path: "/admin/events", per: "EVENTOS_" },
      { nombre: 'Reportes', descripcion: 'Consulta los reportes de eventos', icono: 'mdi-file-document', path: '/admin/reports', per: 'REPORTES_' },
      { nombre: "Roles", descripcion: "Administra los roles", icono: "mdi-shield-account-outline", path: "/admin/roles", color: "blue-grey", per: "ROLES_" },
      { nombre: "Permisos", descripcion: "Administra los permisos", icono: "mdi-shield-lock-outline", path: "/admin/permissions", color: "blue-grey", per: "PERMISOS_" },
      { nombre: "Recursos", descripcion: "Administra los recursos", icono: "mdi-shield-check-outline", path: "/admin/resources", color: "blue-grey", per: "RECURSOS_" },
    ]
  }),
  methods: {
    checkPermissions(p) {
      let per = this.$session.get("permisos");
      if (per) {
        for (let i = 0; i < per.length; i++) {
          if (per[i].search(p) == 0) {
            return true;
          }
        }
      }
      return false;
    },
  },
};
</script>

<style scoped>
</style>
